import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/ServerDownDialog.css";
import serverDownIcon from "../../assets/images/server-down.svg";

const ServerDownDialog = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                className: "server-down-dialog-container",
                sx: { borderRadius: "20px" },
            }}
        >
            <DialogContent>
                <CloseOutlined
                    className="server-down-dialog-close"
                    onClick={onClose}
                />
                <div className="server-down-dialog-content">
                    <div className="server-down-dialog-icon">
                        <img src={serverDownIcon} alt="Server Down" />
                    </div>
                    <div className="server-down-dialog-title-container">
                        <div className="server-down-dialog-title">
                            Uh-oh, our server is taking a nap!
                        </div>
                        <div className="server-down-dialog-subtitle">
                            The server is unavailable at the moment due to maintenance. You can try again later.
                        </div>
                    </div>
                    <Button
                        variant="contained"
                        className="server-down-dialog-button"
                        onClick={onClose}
                    >
                        Okay
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ServerDownDialog;